import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { VulnerabilityExampleEdit } from '../VulnerabilityExampleEdit';

export const Route = createFileRoute('/admin-console/platform-content/ai-training/vulnerability-example/view/$id')({
    staticData: {
        breadcrumb: { title: 'View' },
        ui: { title: 'View vulnerability example' },
        presentation: 'overlay',
    },
    component: ViewVulnerabilityExample,
});

function ViewVulnerabilityExample() {
    const { id } = Route.useParams();
    return (
        <PageController route={Route}>
            <VulnerabilityExampleEdit mode="view" id={id} />
        </PageController>
    );
}
